/* eslint-disable no-useless-escape */
/* eslint-disable no-control-regex */

import Quill from "quill";
import marked from "marked";

import { FORMAT_TYPES, LINE_SEPARATOR } from "./constants.js";

const Delta = Quill.import("delta");

let renderer = new marked.Renderer();
renderer.link = function linkRenderer(href, title, text) {
  // eslint-disable-next-line prefer-reflect
  let link = marked.Renderer.prototype.link.call(this, href, title, text);
  return link.replace("<a", "<a target='_blank' class='ql-link'");
};

/** Disabling unnecessary markdown options */
try {
  marked.Lexer.rules.blockquote.exec = () => {};
  marked.Lexer.rules.list.exec = () => {};
  marked.Lexer.rules.heading.exec = () => {};
  marked.Lexer.rules.fences.exec = () => {};
  marked.Lexer.rules.hr.exec = () => {};
  marked.Lexer.rules.code.exec = () => {};
  marked.InlineLexer.rules.code.exec = () => {};
  marked.prototype.constructor.Parser.prototype.parse = function updateParser(
    src
  ) {
    this.inline = new marked.InlineLexer(
      src.links,
      this.options,
      this.renderer
    );
    this.tokens = src.reverse();
    /** overriding default regex rules */
    this.inline.rules.strong = /^\*{4}|^\*\*([\s\S]*?)\*\*/;
    this.inline.rules.em = /^_{2}|^_([\s\S]*?)_/;
    this.inline.rules.link =
      // eslint-disable-next-line max-len
      /^!?\[((?:\[[^\[\]]*\]|\\.|`[^`]*`|[^\[\]\\`])*?)\]\(\s*(<(?:\\[<>]?|[^\s<>\\])*>|[^\s\x00-\x1f]*)(?:\s+("(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)))?\s*\)/;
    this.inline.rules.text =
      // eslint-disable-next-line max-len
      /^(`+|[^`])(?:[\s\S]*?(?:(?=[\\<!\[`*~]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))|(?= {2,}\n|[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))/;
    var out = "";
    while (this.next()) {
      out += this.tok();
    }
    return out;
  };
  marked.setOptions({
    renderer: renderer
  });
} catch (e) {
  console.info(e);
}

const ATTRIBUTE_ORDER = [
  FORMAT_TYPES.BOLD,
  FORMAT_TYPES.ITALIC,
  FORMAT_TYPES.LINK,
  FORMAT_TYPES.SUPSCRIPT,
  FORMAT_TYPES.SUBSCRIPT
];

const MARKDOWN_DICTS = {
  bold: "**",
  italic: "_",
  superscript: "sup",
  subscript: "sub"
};

export const markdownFromDelta = (delta) => {
  let newDelta = new Delta(delta);
  let markdown = "";
  newDelta.eachLine((line) => {
    markdown = getText(line.ops, markdown);
    markdown += "\n";
  });
  markdown = markdown.replace(/\n$/g, "");
  markdown = markdown.replace(new RegExp(LINE_SEPARATOR, "g"), "\n");
  return markdown;
};

function getText(ops, markdown) {
  ops &&
    ops.forEach((item) => {
      if (!item.attributes) {
        markdown += item.insert;
      } else {
        let sortedItem = sortAttributes(item);
        markdown = getMarks(sortedItem, markdown);
      }
    });
  return markdown;
}

function sortAttributes(item) {
  let { attributes } = item;
  let sortedAttribute = {};
  ATTRIBUTE_ORDER.forEach((item) => {
    if (attributes[item]) sortedAttribute[item] = attributes[item];
  });
  return {
    insert: item.insert,
    attributes: sortedAttribute
  };
}

function getMarks(item, markdown) {
  const itemAttributes = item.attributes;
  const attributes = Object.keys(itemAttributes);
  let newMark = [];
  let flag = false;
  attributes &&
    attributes.length > 0 &&
    attributes.forEach((mark) => {
      if (
        MARKDOWN_DICTS[mark] &&
        ![FORMAT_TYPES.SUBSCRIPT, FORMAT_TYPES.SUPSCRIPT].includes(mark)
      ) {
        newMark.push(MARKDOWN_DICTS[mark]);
      } else if (mark === FORMAT_TYPES.LINK) {
        if (
          attributes.includes(FORMAT_TYPES.SUBSCRIPT) ||
          attributes.includes(FORMAT_TYPES.SUPSCRIPT)
        ) {
          const script =
            itemAttributes[FORMAT_TYPES.SUBSCRIPT] ||
            itemAttributes[FORMAT_TYPES.SUPSCRIPT];
          markdown += `[<${MARKDOWN_DICTS[script]}>${newMark.join("")}${
            item.insert
          }${newMark.reverse().join("")}</${MARKDOWN_DICTS[script]}>](${
            itemAttributes[mark].href
          })`;
        } else {
          markdown += `[${newMark.join("")}${item.insert}${newMark
            .reverse()
            .join("")}](${itemAttributes[mark].href})`;
        }
        flag = true;
      } else if (
        (mark === FORMAT_TYPES.SUBSCRIPT || mark === FORMAT_TYPES.SUPSCRIPT) &&
        !attributes.includes(FORMAT_TYPES.LINK)
      ) {
        markdown += `<${MARKDOWN_DICTS[itemAttributes[mark]]}>${newMark.join(
          ""
        )}${item.insert}${newMark.reverse().join("")}</${
          MARKDOWN_DICTS[itemAttributes[mark]]
        }>`;
        flag = true;
      }
    });
  if (!flag) {
    markdown += newMark.join("") + item.insert + newMark.reverse().join("");
  }
  return markdown;
}

export const htmlMarkup = (markdown) => {
  if (!markdown) return `<p></p>`;
  markdown = markdown.toString();
  markdown = markdown.replace(/\n$/g, "");
  markdown = markdown.replace(/\n$/g, "");
  const markdownArray = markdown.split("\n");
  let rawHTML = "";
  markdownArray &&
    markdownArray.length > 0 &&
    markdownArray.forEach((line) => {
      if (line?.trim()) {
        rawHTML += `${marked(line)}`;
      } else {
        rawHTML += `<p><br /></p>`;
      }
    });
  rawHTML = rawHTML.replace(/\n/gm, "");
  return rawHTML;
};
